/** Read subscriber acquisition / import source. */
export function subscriberSource(row: { source?: string | null } | null | undefined): string {
  if (!row) return '';
  const v = row.source;
  return typeof v === 'string' ? v.trim() : '';
}

/** Human-readable label for a source slug (e.g. pickle-taco-tech-luma). */
export function subscriberSourceLabel(source: string): string {
  const t = source.trim();
  if (!t) return '';
  return t
    .replace(/[_-]+/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
